import { render, staticRenderFns } from "./DetailVodCard.vue?vue&type=template&id=66da21a3&scoped=true&"
import script from "./DetailVodCard.vue?vue&type=script&lang=js&"
export * from "./DetailVodCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailVodCard.vue?vue&type=style&index=0&id=66da21a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da21a3",
  null
  
)

export default component.exports